import Swal from "sweetalert2";

const swalTheme = {
    background: "#ffffff",
    color: "#111827",
    width: "440px",
    padding: "32px",
    borderRadius: "20px",
    backdrop: `rgba(15, 23, 42, 0.5)`,
    buttonsStyling: false,
    customClass: {
        popup: "modern-swal-popup",
        title: "modern-swal-title",
        htmlContainer: "modern-swal-content",
        confirmButton: "modern-swal-confirm-btn",
        cancelButton: "modern-swal-cancel-btn",
        icon: "modern-swal-icon",
        loader: "modern-swal-loader",
    },
};
export const showLoader = ({ title = "Processing Payment", message = "Please wait..." } = {}) => {
    Swal.fire({
        ...swalTheme, title: `<div style="font-size:22px;font-weight:600">${title}</div>`,
        html: `<div style="margin-top:10px;color:#6B7280;font-size:15px;line-height:1.6">${message}</div>`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => { Swal.showLoading() },
    });
};

export const showSuccess = ({ title = "Success", message = "Operation completed successfully.", buttonText = "Done" } = {}) => {
    return Swal.fire({
        ...swalTheme,
        icon: "success",
        title,
        text: message,
        confirmButtonText: buttonText,
        confirmButtonColor: "#111827",
    });
};

export const showError = ({ title = "Something went wrong", message = "Please try again.", buttonText = "Try Again" } = {}) => {
    return Swal.fire({
        ...swalTheme,
        icon: "error",
        title,
        text: message,
        confirmButtonText: buttonText,
        confirmButtonColor: "#DC2626",
    });
};

export const closeSwal = () => Swal.close();